import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Button from '~/components/v2/button'
import FacebookLogin from '~/components/v2/facebook-login'
import Dialog from '~/components/widgets/Dialog'
import { useDialog } from '~/contexts'
import { toLoginAuthUrl, toSignUpAuthUrl } from '~/libs/authUrl'
import * as styles from './styles'

interface Props {
  persistent?: boolean
}

export default function AuthDialog(props: Props): JSX.Element {
  const router = useRouter()
  const { t } = useTranslation('lobby')
  const { toggleAuthDialog } = useDialog()
  const loginAuthUrl = toLoginAuthUrl(router.asPath)
  const signUpAuthUrl = toSignUpAuthUrl(router.asPath)

  return (
    <Dialog customClass={styles.customClass} onClose={props.persistent ? null : toggleAuthDialog}>
      <div className={styles.container}>
        <h1 className={styles.heading}>{t('authDialog.title')} </h1>
        <div className={styles.subheadingContainer}>
          <span className={styles.subheading}>{t('authDialog.subtitle')}</span>
        </div>
        <div className="text-base">{t('authDialog.hint')}</div>
        <div className={styles.buttonContainer}>
          <Button
            theme="primary"
            label={t('authDialog.buttons.labels.signIn')}
            onClick={() => (window.location.href = loginAuthUrl)}
          />
          <Button
            theme="secondary"
            label={t('authDialog.buttons.labels.signUp')}
            onClick={() => (window.location.href = signUpAuthUrl)}
          />
        </div>
        <div className="text-base">{t('authDialog.orText')}</div>
        <FacebookLogin />
      </div>
    </Dialog>
  )
}
